export type WakeLockHandle = {
  release: () => Promise<void>;
};

type ScreenWakeLockSentinel = {
  released: boolean;
  release: () => Promise<void>;
  addEventListener: (type: 'release', listener: () => void) => void;
};

type WakeLockNavigator = Navigator & {
  wakeLock?: {
    request: (type: 'screen') => Promise<ScreenWakeLockSentinel>;
  };
};

/**
 * Keeps the phone screen on while route navigation is active.
 * Uses the Screen Wake Lock API when available (Chrome / Android WebView / many Capacitor shells).
 */
export async function requestScreenWakeLock(): Promise<WakeLockHandle | null> {
  if (typeof navigator === 'undefined') return null;
  const wakeLock = (navigator as WakeLockNavigator).wakeLock;
  if (!wakeLock?.request) return null;

  try {
    const sentinel = await wakeLock.request('screen');
    return {
      release: async () => {
        if (!sentinel.released) await sentinel.release();
      },
    };
  } catch {
    return null;
  }
}

export function isScreenWakeLockSupported(): boolean {
  if (typeof navigator === 'undefined') return false;
  return Boolean((navigator as WakeLockNavigator).wakeLock?.request);
}
